import React, { useState } from "react";

import { Flex, Tooltip } from "components";

import { CropDetailsLine } from "pages/app/all-field-view/utils/CropDetailsUtils";

const CropDetailsValue = ({ entries }: { entries: string[] }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const shouldShowTooltip = entries.length > 1 || isTruncated;

  return (
    <Tooltip
      variant="neutral"
      title={
        shouldShowTooltip ? (
          <Flex vertical>
            {entries.map((entry) => (
              <span key={entry}>{entry}</span>
            ))}
          </Flex>
        ) : undefined
      }
      placement="top"
    >
      <span
        className="timeline-crop-details-panel-value"
        // measured on hover rather than with a ResizeObserver per line, since only the hovered line needs it
        onMouseEnter={(event) => setIsTruncated(event.currentTarget.scrollWidth > event.currentTarget.clientWidth)}
      >
        {entries.join(", ")}
      </span>
    </Tooltip>
  );
};

export const TimelineCropDetailsPanel = ({ lines, isInactive }: { lines: CropDetailsLine[]; isInactive: boolean }) => (
  <Flex vertical className={`timeline-crop-details-panel ${isInactive ? "inactive-card" : ""}`} data-testid="timeline-crop-details-panel">
    {lines.map(({ key, label, entries }) => (
      <Flex vertical key={key} className="timeline-crop-details-panel-line">
        <span className="timeline-crop-details-panel-label">{label}</span>
        <CropDetailsValue entries={entries} />
      </Flex>
    ))}
  </Flex>
);
